import { MONTHS, WEEKDAYS } from './constants.js';

const pad2DigitNum = (num) => `0${num}`.slice(-2);

const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate();

const getFirstWeekdayOfMonth = (year, month) =>
  new Date(year, month - 1, 1).getDay();

const longDateStringToShort = (dateString) => dateString.substr(0, 10);

const stringToDate = (dateString) => {
  const { year, month, date } = parseDateStringToComponents(dateString);

  return new Date(year, month - 1, date);
};

export const addToDate = (dateString, { years = 0, months = 0, days = 0 }) => {
  const { year, month, date } = parseDateStringToComponents(dateString);

  return dateToShortString(
    new Date(+year + years, +month - 1 + months, +date + days)
  );
};

export const createFragmentWithChildren = (children) => {
  const fragment = document.createDocumentFragment();
  children.forEach((child) => fragment.appendChild(child));
  return fragment;
};

export const areDateStringsWithinSameMonth = (dateString1, dateString2) => {
  const { year: y1, month: m1 } = parseDateStringToComponents(dateString1);
  const { year: y2, month: m2 } = parseDateStringToComponents(dateString2);

  return y1 === y2 && m1 === m2;
};

export const dateToShortString = (dateObj) => {
  const year = dateObj.getFullYear();
  const month = pad2DigitNum(dateObj.getMonth() + 1);
  const date = pad2DigitNum(dateObj.getDate());

  return `${year}-${month}-${date}`;
};

export const getMonthInfo = (year, month) => {
  const daysInMonth = getDaysInMonth(year, month);
  const firstWeekday = getFirstWeekdayOfMonth(year, month);

  return {
    daysInMonth,
    firstWeekday,
    paddedDaysInMonth: daysInMonth + firstWeekday,
  };
};

export const getMonthString = (month) => MONTHS[(month - 1) % 12];

export const getWeekdayString = (day) => WEEKDAYS[day];

export const getLabelFromDate = (dateString) => {
  const { year, month } = parseDateStringToComponents(dateString);

  return `${getMonthString(month)} ${year}`;
};

export const getTodayString = () => dateToShortString(new Date());

export const isTodayString = (dateString) => getTodayString() == dateString;

export const isDateStringOutsideRange = (min, max, date) =>
  !!(
    (min && stringToDate(date) < stringToDate(min)) ||
    (max && stringToDate(date) > stringToDate(max))
  );

export const isDateDisabled = (enabledDates, disabledDates, date) => {
  let ret = false;
  if (enabledDates) {
    // date is disabled if not included in enabled dates
    ret = ret || enabledDates.indexOf(date) === -1;
  }
  if (disabledDates) {
    // date is disabled if it is included in disabled dates
    ret = ret || disabledDates.indexOf(date) !== -1;
  }
  return ret;
};

export const parseDateStringToComponents = (dateString) => {
  const [year, month, date] = longDateStringToShort(dateString || '').split(
    '-'
  );

  return {
    year,
    month,
    date,
  };
};

const isDateOutsideRange = (minDate, maxDate, currentDate) =>
  !!(
    (minDate.valueOf() && currentDate < minDate) ||
    (maxDate.valueOf() && currentDate > maxDate)
  );

export const getClosestAllowedDate = (min, max, date) => {
  const minDate = stringToDate(min);
  const maxDate = stringToDate(max);
  const currentDate = stringToDate(date);

  if (!minDate.valueOf() && !maxDate.valueOf() && !currentDate.valueOf()) {
    return;
  }

  if (!currentDate.valueOf()) {
    return getClosestAllowedDate(min, max, getTodayString());
  }

  if (!isDateOutsideRange(minDate, maxDate, currentDate)) {
    return date;
  }

  if (
    Math.abs(minDate - currentDate) < Math.abs(maxDate - currentDate) ||
    !maxDate.valueOf()
  ) {
    return min;
  } 
    return max;
  
};

export const isADateString = (string) =>
  !!(
    string &&
    string.match &&
    string.match(/\d\d\d\d-\d\d-\d\d/) &&
    new Date(string).valueOf()
  );

export const valueOrToday = (value) =>
  isADateString(value) ? value : getTodayString();
